import React, { Component } from 'react';
import { requestHelpers } from '../../../helpers';
import { Content1, Content2, Media1, Media2, Corporate1 } from '../../site/features/partnerships/templates';
import PartnersOverviewPage from '../../site/features/partnerships/PartnersOverviewPage';
import CorporateOverviewPage from '../../site/features/partnerships/CorporateOverviewPage';
import BreakBanner from "../../dashboardNew/components/BreakBanner";

class CMSPage extends Component {
	constructor() {
		super();
		this.state = {}
	}

	componentWillMount() {
		const { params } = this.props;
		const path = this.props.location.pathname;

		requestHelpers
			.getWordPressData(`https://blog.intouchnetworks.com/wp-json/wp/v2/pages?slug=${params.slug}`, true)
			.then(response => {
				let myTemplate = this.templateResolver(path, response.data);
				this.setState({ data: response.data, template: myTemplate, pagenation: response.headers });
			});
	}

	templateResolver(path, data) {

		data = Array.isArray(data) ? data[0] : data;

		if (path === ('/consultancy') || ('/consultancy/*')) {
			if (data.template === "page-template-consultancy-1.php") {
				return <Corporate1 data={data} />;
			}
		}

		if (path === ('/partnerships') || ('/partnerships/*')) {
			switch( data.template ){
				case "page-template-content-1.php":
					return <Content1 data={data} />;
				case "page-template-content-2.php":
					return <Content2 data={data} />;
				case "page-template-media-1.php":
					return <Media1 data={data} />;
				case "page-template-media-2.php":
					return <Media2 data={data} />;
			};
		}
	}

	render() {
		const { template, data } = this.state;

		if (data) {
			return (
				<div className='container-fluid partner-inner-page'>
					{template && template}
					<BreakBanner
						title="See more partners"
						copy="See more of our partners"
						cta_text="Partners Overview"
						cta_link="/partnerships-overview"
					/>
				</div>
			)
		} else {
			return null;
		}
	}
}

export default CMSPage;



// WEBPACK FOOTER //
// src/client/components/common/CMS/CMSPage.js